export default "__VITE_ASSET__BUhX5kDT__"